export const TWO_FA_FORM_BLOCK_NAME = 'twoFaFormBlock';

export const TWO_FA_LAYOUT_BLOCK_NAME = 'twoFaLayoutBlock';

export const TWO_FA_MUST_BE_PAIRED = '2FA_MUST_BE_PAIRED';

export const TWO_FA_REQUIRED = '2FA_REQUIRED';

export const BACKEND_ERROR_INVALID_SESSION_ID = 'BACKEND_ERROR_INVALID_SESSION_ID';
